<template>
  <div class="login">
    <div class="login-left">
      <div class="content">
        <img src="../../assets/img/logo.svg" class="logo" />
        <h6>Reset your password</h6>
        <h5>We will email you instructions to reset your password.</h5>
        <div class="input-label-wrap">
          <a-input v-model="email" placeholder="Email" />
          <span class="message"></span>
        </div>
        <div class="save" @click="forgetPasswd">Reset Password</div>
        <p class="new" @click="goLogin">
          <a>Return to Log in</a>
        </p>
      </div>
    </div>
    <div class="login-right"></div>
  </div>
</template>
<script>
import { ForgetPasswd } from "@/api/user";
export default {
  data() {
    return {
      email: ""
    };
  },
  methods: {
    async goLogin() {
      this.$router.replace("login");
    },
    async forgetPasswd() {
      const { browser } = this.getBrowserInfo();
      let { code, msg } = await ForgetPasswd({
        email: this.email,
        osType: this.GetOSInfo(),
        browerType: browser
      });
      if (code == 200) {
        this.$message.success("success");
      } else {
        this.$message.error(msg);
      }
      console.log(code);
    },
    //获取浏览器类型
    getBrowserInfo() {
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
      var m = ua.match(re);
      try {
        Sys.browser = m[1].replace(/version/, "'safari");
        Sys.ver = m[2];
      } catch (e) {
        console.log("getBrowserInfo fail.");
      }
      return Sys;
    },
    //操作系统类型
    GetOSInfo() {
      var _bit = "";
      var _pf = navigator.platform;
      var appVer = navigator.userAgent;
      if (_pf == "Win32" || _pf == "Windows") {
        if (appVer.indexOf("WOW64") > -1) {
          _bit = "64位";
        } else {
          _bit = "32位";
        }
        if (
          appVer.indexOf("Windows NT 6.0") > -1 ||
          appVer.indexOf("Windows Vista") > -1
        ) {
          if (_bit == "64位" || appVer.indexOf("Windows Vista") > -1) {
            return "Windows_vista " + _bit;
          } else {
            return "Unknow1";
          }
        } else if (
          appVer.indexOf("Windows NT 6.1") > -1 ||
          appVer.indexOf("Windows 7") > -1
        ) {
          if (_bit == "32位" || appVer.indexOf("Windows 7") > -1) {
            return "Windows_7 " + _bit;
          } else {
            return "Unknow";
          }
        } else {
          try {
            var _winName = Array("2000", "XP", "2003");
            var _ntNum = appVer.match(/Windows NT 5.\d/i).toString();
            return (
              "Windows_" +
              _winName[_ntNum.replace(/Windows NT 5.(\d)/i, "$1")] +
              " " +
              _bit
            );
          } catch (e) {
            return "Windows";
          }
        }
      } else if (_pf == "Mac68K" || _pf == "MacPPC" || _pf == "Macintosh") {
        return "Mac";
      } else if (_pf == "X11") {
        return "Unix";
      } else if (String(_pf).indexOf("Linux") > -1) {
        return "Linux";
      } else {
        return "Unknow";
      }
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/user.css";
</style>
